import { observable, action } from 'mobx';
import Constants from '../common/Constants';
import Utils from '../common/Utils'; 

export default class FilterBarStore {
  @observable announcementFilter = {
    date: Utils.currentUTCDate(),
    isMatchAnn: false,
  }

  @observable dateFilter = Utils.currentUTCDate();
  @observable monthRangeFilter = Utils.lastThreeMonthsUTCDate();
  @observable sportFilter = 29;
  @observable myBonusesFilterDate = Constants.DATE_FILTER.THIRTY_DAY.value;
  @observable bonusesFilterDateRange = {fromDate: null, toDate: null};
  @observable isOpenBonusDatePicker = false;

  @action updateAnnouncementFilter(key, value) {
    this.announcementFilter[key] = value;
  }
  
  @action updateMyBonusesFilter(value) {
    this.myBonusesFilterDate = value
  }
  
  @action updateDateFilter(newDate) {
    this.dateFilter = newDate;
  }
  
  @action updateMonthRangeFilter(newDate) {
    this.monthRangeFilter = newDate;
  }
  
  @action updateSportFilter(sportId) {
    this.sportFilter = sportId;
  }

  @action updateIsOpenBonusDateFilter(value) {
    this.isOpenBonusDatePicker = value;
  }

  @action updateBonusesFilterDateRange(value) {
    this.bonusesFilterDateRange = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/FilterBarStore.js